var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.418l1.358-4.825A9.656 9.656 0 01.025 9.686C.025 4.346 4.37 0 9.711 0s9.686 4.345 9.686 9.686-4.345 9.686-9.686 9.686a9.673 9.673 0 01-4.735-1.235L0 19.418zm5.23-3.043l.297.181A8.027 8.027 0 009.71 17.73c4.435 0 8.043-3.608 8.043-8.043 0-4.435-3.608-8.043-8.043-8.043-4.435 0-8.043 3.608-8.043 8.043 0 1.545.44 3.046 1.27 4.34l.2.31-.783 2.78 2.875-.74z",
    fill: "#45355C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.989 5.178l-.629-.034a.76.76 0 00-.54.185c-.305.264-.792.776-.942 1.442-.223.994.122 2.211 1.015 3.429.892 1.217 2.556 3.164 5.497 3.996.948.268 1.693.087 2.269-.281.455-.291.77-.76.882-1.288l.1-.469a.326.326 0 00-.181-.364l-2.124-.979a.326.326 0 00-.395.097l-.834 1.081a.239.239 0 01-.268.08c-.57-.2-2.484-1.002-3.533-3.024a.241.241 0 01.03-.269l.797-.922a.326.326 0 00.053-.34L7.27 5.374a.326.326 0 00-.281-.197z",
    fill: "#45355C"
  })));
}
export default SvgShareWhatsapp;